import { render } from "./RestorationView.vue?vue&type=template&id=1e52ad32&scoped=true"
import script from "./RestorationView.vue?vue&type=script&lang=js"
export * from "./RestorationView.vue?vue&type=script&lang=js"

import "./RestorationView.vue?vue&type=style&index=0&id=1e52ad32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e52ad32"]])

export default __exports__